// scroll to anchor on click
$(document).on("click", "a[href^='#']", function () {
    var url = $(this).attr('href');
    if (url !== '' && url !== '#' && $(url).length) {
        $('html, body').animate({ scrollTop: $('a[href="' + url + '"]').offset().top - 150 });
    }
});

// body click to remove class
$(document).on("click", "body", function () {
    $('body').removeClass("bodyclass");
});
